import { SET_CONTAINER, SET_LOADING, SET_MODAL, SET_STATUS, SET_TIME, SET_SYSTEM_POPUP } from '@/store/mutations.type'
import loader from '@/loader'

const state = {
    loading: {
        makeOrder: false,
        checkIiko: false,
        sendSms: false,
        getGeoAddress: false,
        getInputGeoAddress: false,
        setProfileAddress: false,
        updateBasket: false,
        addToBasket: false,
        addToUpsellBasket: false,
        guardSortOutlets: false,
        selectCategory: false,
        fetchProducts: false,
        fetchSearch: false,
        setArea: false
    },
    status: {
        makeOrder: false,
        checkIiko: false,
        fetchProducts: false,
        fetchOutletAdditional: false
    },
    modal: {
        resource: false,
        product: false,
        datefilter: false,
        search: false,
        upsell: false,
        block: false,
        options: false,
        count: false,
        clear: false,
        time: false,
        sms: false,
        searchFull: false,
        compactSelector: false,
        promocode: false,
        callWaiter: false,
        waiterCalled: false,
        scrollTop: 0,
        system: false,
        systemText: '',
    },
    time: new Date,
    container: null
}

const getters = {
    time(state) {
        return state.time
    },
    loading(state) {
        return state.loading
    },
    status(state) {
        return state.status
    },
    modal(state) {
        return state.modal
    },
    container(state) {
        return state.container
    },
    const () {
        return {
            CONTAINER_TAB: 'tab',
            CONTAINER_IFRAME: 'ifarme',
            CONTAINER_FACEBOOK: 'facebook'
        }
    }
}

export const actions = {}

export const mutations = {
    [SET_TIME](state) {
        state.time = new Date
    },
    [SET_LOADING](state, { process, loading }) {
        state.loading[process] = Boolean(loading)
    },
    [SET_STATUS](state, { process, status }) {
        state.status[process] = status
    },
    [SET_CONTAINER](state, data) {
        state.container = data
    },
    [SET_MODAL](state, { modal, status }) {
        state.modal[modal] = status

        if (modal === 'search' && loader.WEBVIEW_MODE === loader.const.ECOMMERCE) {
            return
        }

        if (status) {
            state.modal.scrollTop = window.scrollY
            document.body.classList.add('overflow')
            const app = document.getElementById('app')
            app.classList.add('overflow')
            app.style.top = -state.modal.scrollTop + 'px'
        } else {
            document.body.classList.remove('overflow')
            const app = document.getElementById('app')
            app.classList.remove('overflow')
            app.style.top = ""
            window.scrollTo(0, state.modal.scrollTop)
        }
    },
    [SET_SYSTEM_POPUP](state, { status, text }) {
        state.modal.systemText = text;
        state.modal.system = status;
    },
}

export default {
    state,
    actions,
    mutations,
    getters
}